module.exports = "<div class=oui-spinner__container> <div class=oui-spinner__image></div> </div> ";